module.exports = __webpack_public_path__ + "static/media/poster_2020SlingshotR.3f6f8a80.png";